import { Helmet } from "react-helmet-async";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import GenericStyleDetail from "./GenericStyleDetail";
import { styleTypes } from "../../enums/styleTypes";

const ListStyleDetail = () => {
  return (
    <div className="page-content">
      <Helmet>
        <title>List Style</title>
      </Helmet>
      <Container fluid>
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <Row className="my-2">
                  <GenericStyleDetail type={styleTypes.LIST}/>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ListStyleDetail;
